module.exports = __webpack_public_path__ + "calculator/cummins-generator-calculator/static/media/onan-p2500i.09a333b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/images/products/onan-p2500i.png
// module id = 820
// module chunks = 0